export const GSTREGISTER_REPORT_REQUEST = 'GSTREGISTER_REPORT_REQUEST';
export const GSTREGISTER_REPORT_SUCCESS = 'GSTREGISTER_REPORT_SUCCESS';
export const GSTREGISTER_REPORT_FAILURE = 'GSTREGISTER_REPORT_FAILURE';